export enum Page {
	TEST_SETTINGS = 'testSettings',
	REPORT = 'report',
	REQUESTS = 'requests',
	ABOUT = 'about',
}